import { useEffect, useContext, useState } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { reauthLinkedInMember } from '@bingads-webui-campaign-react/linkedin-data';

import { COMPANY_PAGE_LINKING_ACTIONS } from '../reducer';
import { useLinkedInLinking } from './use-linkedin-linking';

export const useRefreshMemberToken = (state, dispatch, logger) => {
  const { scope } = useContext(ScopeContext);
  const { cid, aid } = scope.values;
  const [isProcessing, setIsProcessing] = useState(false);

  const { isRefreshingToken, isMemberTokenActive } = state;
  const login = useLinkedInLinking({ windowObject: window });

  useEffect(() => {
    if (isRefreshingToken && !isProcessing && !isMemberTokenActive) {
      setIsProcessing(true);
      login(logger).then(authorizationData => reauthLinkedInMember(cid, aid, { // Replace with real API for refresh token here
        authorizationData,
      }).then((Res) => {
        logger.trace(`Member token refreshed: ${JSON.stringify(Res)}`);
        dispatch({
          type: COMPANY_PAGE_LINKING_ACTIONS.MEMBER_TOKEN_REFRESHED,
        });
      })).catch((err) => {
        logger.trace(`Failed to refresh member token: ${JSON.stringify(err)}`);
        dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.MEMBER_TOKEN_REFRESH_FAILED, refreshTokenError: err });
      }).finally(() => {
        setIsProcessing(false);
      });
    }
  }, [aid, cid, dispatch, isRefreshingToken, isProcessing, logger, login, isMemberTokenActive]);
};
